import React, { PropsWithChildren, useContext } from 'react';
import { ChatType } from '../dto';

type ChatRealmContextProps = {
  chatType: ChatType | null;
  chatSubtype: string | null;
};

const ChatRealmContext = React.createContext<ChatRealmContextProps>({
  chatType: null,
  chatSubtype: null,
});

export const useChatRealmContext = () => {
  return useContext(ChatRealmContext);
};

export const ChatRealmContextProvider = (
  props: PropsWithChildren<{ chatType: ChatType; chatSubtype?: string | null }>
) => {
  const { chatType, chatSubtype, children } = props;

  return (
    <ChatRealmContext.Provider
      value={{
        chatType: chatType,
        chatSubtype: chatSubtype ?? null,
      }}
    >
      {children}
    </ChatRealmContext.Provider>
  );
};
